import { Action } from '@ngrx/store';
import { NavigationExtras } from '@angular/router';

export enum LifeCycleActionTypes {
  AppInit                  = '@digitaix/core/life-cycle/APP_INIT',
  AppAuthenticated         = '@digitaix/core/life-cycle/APP_AUTHENTICATED',
  AppUnauthenticated       = '@digitaix/core/life-cycle/APP_UNAUTHENTICATED',
  AppIsStable              = '@digitaix/core/life-cycle/APP_IS_STABLE',
  AppIsUnstable            = '@digitaix/core/life-cycle/APP_IS_UNSTABLE',
  AppConfigLoaded          = '@digitaix/core/life-cycle/APP_CONFIG_LOADED',
  AppDocumentServiceLoaded = '@digitaix/core/life-cycle/APP_DOCUMENT_SERVICE_LOADED',
  AppStartNavigate            = '@digitaix/core/life-cycle/APP_START_NAVIGATE',
  AppStopNavigate            = '@digitaix/core/life-cycle/APP_STOP_NAVIGATE',
}

export class AppIsReady implements Action {
  public static TYPE   = '@digitaix/core/life-cycle/APP_IS_READY';
  public readonly type = AppIsReady.TYPE;
}

export class AppNavigateTo implements Action {
  public static TYPE = '@digitaix/core/life-cycle/APP_NAVIGATE_TO';
  public readonly type = AppNavigateTo.TYPE;

  constructor(public commands: any[], public tracer: string, public extras?: NavigationExtras) {}
}

export class AppStartNavigate implements Action {
  public readonly type = LifeCycleActionTypes.AppStartNavigate;
}

export class AppStopNavigate implements Action {
  public readonly type = LifeCycleActionTypes.AppStopNavigate;
}

export class AppInit implements Action {
  public readonly type = LifeCycleActionTypes.AppInit;
}

export class AppAuthenticated implements Action {
  public readonly type = LifeCycleActionTypes.AppAuthenticated;
}

export class AppUnauthenticated implements Action {
  public readonly type = LifeCycleActionTypes.AppUnauthenticated;
}

export class AppIsStable implements Action {
  public readonly type = LifeCycleActionTypes.AppIsStable;
}

export class AppIsUnstable implements Action {
  public readonly type = LifeCycleActionTypes.AppIsUnstable;
}

export class AppConfigLoaded implements Action {
  public readonly type = LifeCycleActionTypes.AppConfigLoaded;
}

export class AppDocumentServiceLoaded implements Action {
  public readonly type = LifeCycleActionTypes.AppDocumentServiceLoaded;
}

export type LifeCycleActions =
  AppInit
  | AppAuthenticated
  | AppUnauthenticated
  | AppIsStable
  | AppIsUnstable
  | AppConfigLoaded
  | AppStopNavigate
  | AppStartNavigate
  | AppDocumentServiceLoaded;
